// migrated to src_new/ui/core/page/Error/Error.tsx
import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { themeGet } from '@styled-system/theme-get';
import { A } from '@xingternal/rebranding-adapter';
import { Button } from '@xingternal/winery-ui/lib/Button';
import { Icon } from '@xingternal/winery-ui/lib/Icon';
import { Text } from '@xingternal/winery-ui/lib/Text';
import { Flex } from '@xingternal/winery-ui/lib/UI';
import { XTS_EMAIL } from '@src/constants';
import { MEDIA_SIZES } from '@helpers/styles';
import { BrandProvider } from '@infrastructure/styling/BrandProvider';

const i18ns = {
  tryAgain: 'XSS_TRY_AGAIN',
  error: 'XSS_ERROR_OOPS',
  emailMessage: 'XSS_BRIEFING_DASHBOARD_ERROR_CONTACT',
};

const ErrorWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ErrorMessage = styled(Text).attrs(() => ({
  color: 'secondaryText',
}))`
  font-size: ${themeGet('fontSizes.4')};
  margin-top: ${themeGet('space.4')};
  margin-bottom: ${themeGet('space.6')};
  ${MEDIA_SIZES.MEDIUM_AND_MORE} {
    font-size: ${themeGet('fontSizes.6')};
  }
`;

const EmailLink = styled(A)`
  cursor: pointer;
  margin: auto;
`;

const EmailText = styled(Text)`
  text-align: center;
`;

const EmailFlex = styled(Flex)`
  flex-direction: column;
  margin-left: 56px;
  margin-right: 56px;
  margin-top: ${themeGet('space.6')};
`;

const PageError = () => {
  const { formatMessage } = useIntl();

  return (
    <BrandProvider>
      <ErrorWrapper>
        <Icon name="CoreWarning" color="grey400" height={48} width={48} />
        <ErrorMessage>{formatMessage({ id: i18ns.error })}</ErrorMessage>
        <Button variant="secondary" onClick={() => window.location.reload()}>
          {formatMessage({ id: i18ns.tryAgain })}
        </Button>
        <EmailFlex>
          <EmailText>{formatMessage({ id: i18ns.emailMessage })}</EmailText>
          <EmailLink data-testid="email-link" href={`mailto:${XTS_EMAIL}`}>
            {XTS_EMAIL}
          </EmailLink>
        </EmailFlex>
      </ErrorWrapper>
    </BrandProvider>
  );
};

export { PageError };
